export default __webpack_public_path__ + "static/media/avatar-review-6.76e22a63.svg";